// Time constants in milliseconds
export const ONE_SECOND = 1000;
export const ONE_MINUTE = ONE_SECOND * 60;
export const FIVE_MINUTES = ONE_MINUTE * 5;
export const THIRTY_MINUTES = ONE_MINUTE * 30;
export const ONE_HOUR = ONE_MINUTE * 60;
export const ONE_DAY = ONE_HOUR * 24;
